export default {
    init() {
        this.initDynamicForms();
    },
    finalize() {

    },
    initDynamicForms: function () {
        const $forms = $('[data-init="dynamic_form"]');

        if ($forms.length) {
            $forms.each((key, form) => {
                this.initDynamicForm(form);
            })
        }
    },
    initDynamicForm: function (form) {
        let self = this,
            clientId;

        if (!form) {
            return;
        }

        form = $(form);

        form.parsley({
            errorsContainer: function (elem) {
                return elem.$element.siblings('.error-message');
            },
        });

        let isReCaptchaReady = !!(window.reCaptchaKey && typeof grecaptcha !== 'undefined');


        form.on('submit', function (e) {
            e.preventDefault();

            if (!$(this)[0].checkValidity()) {
                return false;
            }

            const action = $(this).prop('action'),
                response_container = form.find('.response');

            let formData = new FormData(),
                formParams = form.serializeArray();

            $.each(form.find('input[type="file"]'), function (i, tag) {
                $.each($(tag)[0].files, function (i, file) {
                    formData.append(tag.name, file);
                });
            });

            $.each(formParams, function (i, val) {
                formData.append(val.name, val.value);
            });

            const token = document.head.querySelector('meta[name="csrf-token"]');

            if (token) {
                formData.append('_token', token.content)
            } else {
                console.error('CSRF token not found!');
            }

            if (isReCaptchaReady) {
                grecaptcha.ready(() => {
                    grecaptcha.execute(window.reCaptchaKey, {action: 'contact_form'})
                        .then((token) => {
                            formData.append('g-recaptcha-response', token);
                            self.sendContactForm(action, formData, response_container, form);
                        });
                });
            } else {
                self.sendContactForm(action, formData, response_container, form);
            }
        });
    },
    sendContactForm: function (action, data, response_container, form) {
        $.ajax({
            url: action,
            data: data,
            method: 'POST',
            dataType: 'json',
            cache: false,
            contentType: false,
            processData: false,
            success: (response) => {
                if (response.status && response_container.length) {
                    response_container.html(response.message);
                    response_container.show();

                    setTimeout(() => {
                        response_container.hide();
                    }, 5000);
                }
                form[0].reset();
            },
        });
    }
};
